import classNames from 'classnames/bind';
import loadable from '@loadable/component';

import { useSelector } from 'react-redux';
import { LOCATIONS_SENTIMENT_BREADCRUMBS } from '../../../data/directory/constants';

import Breadcrumbs from '../../Breadcrumbs';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';

const SearchbarInner = loadable(() => import('../../SearchbarComponents/SearchbarInner'));
const SentimentFilterBar = loadable(() => import('./SentimentFilterBar'));
const SentimentWorldChart = loadable(() => import('./SentimentWorldChart'));
const SentimentStories = loadable(() => import('./SentimentStories'));

const cx = classNames.bind(Styles);

const LocationsSentiment = (props) => {
  const {
    isLocationsTab, slug, slugType, piwikEnabled, user, parents,
  } = props;

  const { searchBarActive } = useSelector((state) => state.searchReducers);

  return (
    <div className={cx('locations_sentiments', { locations_tab: isLocationsTab }, searchBarActive && 'blurred')}>
      {
        !isLocationsTab && (
          <>
            <Breadcrumbs items={LOCATIONS_SENTIMENT_BREADCRUMBS} />
            <div className={Styles.sentiments_title}>
              Sentiment by Location
            </div>
            <div className={Styles.sentiments_desc}>
              Location isn&apos;t everything, and neither is market psychology.
              But market sentiment for countries to cities bolsters investment due diligence,
              a critical tool for every investor or trader. &nbsp;
              <a
                href="https://www.cityfalcon.ai/features/sentiment"
                target="_blank"
                rel="noreferrer noopener"
              >
                Learn more.
              </a>
            </div>
          </>
        )
      }
      <div className={cx('filters_wrapper')}>
        <SentimentFilterBar />
        {/* Remove dummy false value to open back location filters, when backend would be ready */}
        {!isLocationsTab && false && (
          <div className={cx('searchbar')}>
            <SearchbarInner
              searchStyles={[
                'fixed_searchbar',
                'location_searchbar',
              ]}
              oneItem
              searchbarType="locationSearchbar"
              piwikEnabled={piwikEnabled}
            />
          </div>
        )}
      </div>
      <SentimentWorldChart
        isLocationsTab={isLocationsTab}
        topic={slug}
        slugType={slugType}
        parents={parents}
      />
      <SentimentStories
        user={user}
        piwikEnabled={piwikEnabled}
        isLocationsTab={isLocationsTab}
        topic={slug}
        slugType={slugType}
        isLocationPage
      />
    </div>
  );
};

export default withMetatag(LocationsSentiment, 'directory/sentiment/locations');
